import React from 'react';
import { Typography } from '@mui/material';

export const InvoiceDetailsDialogTitle: React.FC<{ children: React.ReactNode }> = (props) => {
    return (
        <Typography
            gutterBottom
            variant={'h3'}
            sx={{ textAlign: 'center', paddingBottom: '10px' }}
        >
            {props.children}
        </Typography>
    );
};
